var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.627,
    height: 12.591,
    viewBox: "0 0 17.627 12.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214964",
    "data-name": "Path 214964",
    d: "M23.877,20.639a1.889,1.889,0,0,0-1.889-1.889H8.139A1.889,1.889,0,0,0,6.25,20.639v8.814a1.833,1.833,0,0,0,.189.806,2.018,2.018,0,0,0,1.7,1.083h13.85A1.862,1.862,0,0,0,23.657,30.3a1.816,1.816,0,0,0,.22-.844Zm-8.53,4.917a.4.4,0,0,1-.567,0L8.466,20.009h13.22ZM7.509,20.846l4.444,3.9L7.509,29.194ZM8.4,30.082l4.508-4.5,1.045.919a1.65,1.65,0,0,0,2.228,0l1.045-.919,4.508,4.5Zm9.777-5.332,4.444-3.9v8.348Z",
    transform: "translate(-6.25 -18.75)",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.5260d73693e3f91a1c89fbd8a0dcc9a9.svg";
export { ForwardRef as ReactComponent };